
export default function init() {
	document.querySelectorAll('.downloadForm').forEach(parentElement => {
		const file = parentElement.getAttribute('data-file');
		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				for (let i = 0; i < mutation.addedNodes.length; i++) {
					const addedNode = mutation.addedNodes.item(i);
					// NOTE: success message needs to be inside a paragraph in the CKEditor in HubSpot (https://app.hubspot.com/forms/23566133/editor/5c8fd1cf-f161-4ee3-ac36-0651cd6042dc/edit/options?redirectUrl=%2Fforms%2F23566133%2F)
					// Otherwise, this breaks.
					// It's difficult to tell if it's inside a paragraph because CKEditor's "source view" is broken - need to inspect in Dev Tools.
					if (addedNode instanceof HTMLElement && !addedNode.classList.contains('modified') && addedNode.parentElement?.classList.contains('submitted-message')) {
						addedNode.classList.toggle('modified', true);
						const successMessage = addedNode.parentElement;
						const text = addedNode.textContent;
						const regex = /click here/i;
					
						if (regex.test(text)) {
							observer.disconnect();
							successMessage.innerHTML = text.replace(regex, (match) => `<a href="${file}">${match}</a>`);
							observer.observe(parentElement, { childList: true, subtree: true });
						}
					}
				}
			});
		});
		observer.observe(parentElement, { childList: true, subtree: true });
	});
}